import { useTranslation } from 'react-i18next'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import { ModalMessage, ModalActionsRow, compactModalOverrides } from './styled-components'

interface Props {
  isOpen: boolean
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteAddressConfirmModal = ({ isOpen, isLoading, onClose, onConfirm }: Props) => {
  const { t } = useTranslation()

  return (
    <SDModal
      isOpen={isOpen}
      openHandler={onClose}
      title={t('subscriptionForm:address_module.delete_address.confirm_title')}
      overrides={compactModalOverrides}
      sections={
        <>
          <ModalMessage>{t('subscriptionForm:address_module.delete_address.confirm_message')}</ModalMessage>
          <ModalActionsRow>
            {/* @ts-ignore */}
            <SDButton kind='secondary' onClick={onClose}>
              {t('subscriptionForm:address_module.delete_address.no')}
            </SDButton>
            {/* @ts-ignore */}
            <SDButton onClick={onConfirm} isLoading={isLoading} kind='primary'>
              {t('subscriptionForm:address_module.delete_address.yes')}
            </SDButton>
          </ModalActionsRow>
        </>
      }
    />
  )
}

export default DeleteAddressConfirmModal
